import React, { useEffect, useState } from 'react';
import { get } from '../../utils/api';

function MonthlyReports({ childId }) {
  const [reports, setReports] = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingUrlId, setLoadingUrlId] = useState(null);

  useEffect(() => {
    if (!childId) return;
    setLoading(true);
    get(`/monthly-reports/child/${childId}`, true)
      .then((data) => setReports(data || []))
      .catch(() => setReports([]))
      .finally(() => setLoading(false));
  }, [childId]);

  const handleViewReport = async (reportId) => {
    setLoadingUrlId(reportId);
    try {
      const { url } = await get(`/monthly-reports/${reportId}/pdf-url`, true);
      window.open(url, '_blank', 'noopener,noreferrer');
    } catch {
      alert('Could not load report. Please try again.');
    } finally {
      setLoadingUrlId(null);
    }
  };

  const completedReports = reports.filter((r) => r.status === 'complete' && r.pdfS3Key);

  if (loading) {
    return (
      <div className="py-10 flex items-center gap-2 text-gray-600">
        <span className="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-gray-600" />
        <span>Loading reports...</span>
      </div>
    );
  }

  if (completedReports.length === 0) {
    return (
      <div className="p-3 rounded-lg border bg-gray-50 text-gray-700 text-sm">
        No monthly reports available yet.
      </div>
    );
  }

  return (
    <div className="space-y-3">
      {completedReports.map((report) => {
        const month = new Date(report.reportMonth).toLocaleString('en-GB', {
          month: 'long',
          year: 'numeric',
        });
        return (
          <div
            key={report._id}
            className="flex items-center justify-between rounded-lg border border-gray-200 p-4"
          >
            <span className="font-medium text-gray-800">{month}</span>
            <button
              onClick={() => handleViewReport(report._id)}
              disabled={loadingUrlId === report._id}
              className="rounded-md bg-indigo-600 px-3 py-1.5 text-sm text-white hover:bg-indigo-700 disabled:opacity-50"
            >
              {loadingUrlId === report._id ? 'Loading...' : 'View Report'}
            </button>
          </div>
        );
      })}
    </div>
  );
}

export default MonthlyReports;
